import '../styles/common.css';

import { Link, graphql } from 'gatsby';

import CollapsibleSection from '../components/shared/collapsable';
import HeroBanner from '../components/shared/hero-banner';
import Layout from '../components/layout';
import React from 'react';
import SEO from '../components/seo';
import ScrollAnimation from 'react-animate-on-scroll';
import SectionTitle from '../components/shared/section-titles';
import { TitleH1 } from './magazini';
import meta from '../constants/meta-descriptions';
import peacemakerImage from '../images/osvobodi-se/peacemaker-small.webp';
import playImage from '../images/osvobodi-se/play-small.webp';
import strahilImage from '../images/osvobodi-se/strahil-small.webp';
import svobodaImage from '../images/osvobodi-se/svoboda-small.webp';
import tiktopImage from '../images/osvobodi-se/tiktok-small.webp';

const features = [
	{
		number: '01',
		title: 'Програма Свобода',
		text:
			'Договорът ти се адаптира към твоя живот, а не обратното. Сменяй плана си към по-висок или по-нисък по всяко време, без промяна на крайния срок. Ползваш пълна свобода да паузираш услугата си за до 5 месеца — не ползваш, не плащаш.',
		bullets: ['Свободна смяна на плана: Сменяй нагоре или надолу без удължаване на договора.', 'До 5 месеца пауза: Спираш и пускаш когато поискаш — плащаш само за активните дни.'],
		cta: 'Виж повече',
		href: '/osvobodi-se/svoboda/',
		image: svobodaImage
	},
	{
		number: '02',
		title: 'Доведи приятел',
		text:
			'Добрите неща се споделят. Когато твоят приятел или съсед се включи в NetSurf, и двамата прибирате по €30 отстъпка от сметките си. Без уловки и без таван на поканите — колкото повече хора доведеш, толкова по-дълго ползваш безплатен интернет и телевизия.',
		bullets: ['по €30 и за двама ви: Вземате чиста отстъпка от таксите си още с първата инсталация.', 'Нулев лимит: Кани колкото искаш хора — занулявай сметките си месец след месец.'],
		cta: 'Разбери как',
		href: '/osvobodi-se/dovedi-priyatel/',
		image: strahilImage
	},
	{
		number: '03',
		title: 'TIP TOK',
		text:
			'Токът спира, интернетът — не. С нашето “джобно спасение за Wi-Fi-то“ разполагаш с до 2 часа стабилен интернет, докато комшиите са на свещи. Сърфирай, работи от лаптопа или си догледай филма на телефона, докато кварталът е на тъмно.',
		bullets: ['До 2 часа онлайн без ток: Мини батерия, която пази Wi-Fi мрежата ти жива при всяка авария.', 'Връзка за всички устройства: Телефони, лаптопи и таблети остават в мрежата без секунда прекъсване.'],
		cta: 'Виж как',
		href: '/osvobodi-se/tip-tok/',
		image: tiktopImage
	},
	{
		number: '04',
		title: 'NetSurf Play',
		text:
			'С NetSurf Play телевизията е там, където си ти — вземаш екрана от хола и си го пускаш на телефона, таблета или лаптопа. Но това не е просто ТВ ап, а дистанционното за целия ти договор с нас: плащаш таксата за секунди, управляваш домашния си рутер и контролираш достъпа на децата.',
		bullets: ['Екранът ти в движение: Всички канали с теб на път, без приемници и кабели', 'Управление без разкарване: Сметки, Wi-Fi настройки и „Закрилникът+“ — директно от джоба ти.'],
		cta: 'Виж повече',
		href: '/osvobodi-se/netsurf-play/',
		image: playImage
	},
	{
		number: '05',
		title: 'Закрилникът',
		text:
			'Пуснете сигурността на автопилот и си сипете кафе. Закрилникът е денонощният пазач на вашия Wi-Fi, който бие шута на вирусите, фишинг измамите и „съмнителните“ линкове още преди да са стигнали до екрана ти. А ти държиш родителския контрол за децата — бързо, лесно и без излишни семейни драми със Закрилникът +.',
		bullets: ['Защита без гимнастики: Пази всички телефони, лаптопи и умни джаджи на ниво рутер — без инсталиране на досадни програми.', 'Мир у дома: Филтрираш кофти съдържанието и затваряш кранчето на нежеланите сайтове с 1 клик в APP.'],
		cta: 'Закрилникът +',
		href: '/osvobodi-se/internet-zashtita/',
		image: peacemakerImage
	}
];

const services = [
	{
		title: 'Свързване до  60 секунди. Денонощно. Без роботчета и без асансьорна музика.',
		text:
			'Когато имаш въпрос, вдигаме телефона до 60 секунди — дори в 3 през нощта в неделя. Без бота Гошо и без да слушаш класическа музика на изчакване.'
	},
	{
		title: 'Подземна GPON мрежа. Имунитет срещу бури, порои и кофти време.',
		text:
			'Кабелите ни са дълбоко под земята. Дъжд, сняг, ураганен вятър — интернетът ти си върви стабилно, докато навън пада небето.'
	},
	{
		title: 'Без индексиране на цените Цената си е цената. До края.',
		text:
			'Няма годишно поскъпване „заради инфлацията“, няма скрити такси и няма изненади в сметката. Плащаш точно толкова, за колкото си се договорил.'
	},

];

const faqs = [
	{
		title: 'Колко бързо ще дойдете да ме свържете?',
		content:
			'Обикновено идваме от 24 до 72 часа. Техниците ни работят чисто, бързо и не оставят дупки като след ремонт в хола ти.'
	},
	{
		title: 'Има ли наистина някакви скрити такси или „инфлационни“ изненади?',
		content:
			'Не. Цената, която виждаш в договора, е цената, която плащаш всеки месец. Без индексации, без такса „въздух“ и без изненади във фактурата.'
	},
	{
		title: 'Как работи Програма Свобода, ако замина за чужбина или на море?',
		content:
			'Замразяваш си услугата само с едно обаждане за до 5 месеца. През това време плащаш точно 0 €. Без да прекратяваш договора си.'
	},
	{
		title: 'Трябва ли ми специален рутер за Закрилника+ и TIP TOK батерията?',
		content:
			'Ние ти осигуряваме необходимото оборудване (Wi-Fi 6 рутер). Всичко се настройва за минути и се управляваш Закрилникът + директно през телефона ти.'
	},
	{
		title: 'Как да взема бонус от €30 от „Доведи приятел“?',
		content:
			'Препоръчай ни на твой приятел, когато той се включи, и двамата получавате по €30 отстъпка. Без лимит на поканените приятели!'
	}
];

export default ({ data }) => {
	return (
		<div style={{ backgroundColor: '#F9F9FF', minHeight: '100vh' }}>
			<Layout>
				<SEO
					title={meta.osvobodiSe.title}
					titleTemplate={`%s`}
					description={meta.osvobodiSe.metaDescription}
				/>

				<HeroBanner
					image={data.heroDesktop.childImageSharp.fluid.src}
					imageMobile={data.heroMobile.childImageSharp.fluid.src}
					imageAlt="Освободи се"
				/>

				<div className="osvobodi-container" style={{ paddingTop: '2rem' }}>
					<div>
						<SectionTitle undertext="Паузирай договора си когато искаш, вземи €30 за всеки
								поканен приятел и имай интернет дори без ток. Получаваш
								гигабитова връзка, кристална телевизия и пълна защита за
								семейството си у дома.">
							<TitleH1>
								Интернетът е от нас. Свободата да го ползваш по твоите
								правила — също.
							</TitleH1>

						</SectionTitle>

						<div className="d-flex justify-content-center mt-4">
							<div className="osvobodi-cta-group">
								<button
									type="button"
									className="btn btn-primary dark-blue py-3 osvobodi-plans-btn"

									onClick={() => {
										const target = document.getElementById(
											'osvobodi-nachine'
										);
										if (target) {
											target.scrollIntoView({
												behavior: 'smooth',
												block: 'start'
											});
										}
									}}
								>
									Открий Свободата
									<span aria-hidden="true"> ›</span>
								</button>
								<Link
									to="/za-doma/"
									className="btn btn-primary green py-3"
								>
									Нашите Планове

								</Link>
							</div>
						</div>
					</div>
				</div>

				<div className="osvobodi-band osvobodi-features-header">
					<div className="osvobodi-container">
						<SectionTitle>
							<TitleH1 id="osvobodi-nachine" className="osvobodi-nachine-title">
								5 начина да се освободиш с NetSurf
							</TitleH1>
						</SectionTitle>
					</div>
				</div>

				{features.map(({ number, title, text, bullets, cta, href, image }, i) => (
					<div
						key={number}
						className={
							i % 2 ? 'osvobodi-band alt' : 'osvobodi-band'
						}
					>
						<div className="osvobodi-container">
							<ScrollAnimation animateIn="fadeIn" animateOnce={true}>
								<div className="row align-items-center">
									<div
										className={
											'col-12 col-lg-6 px-lg-5 ' +
											(i % 2 ? 'order-1' : 'order-1 order-lg-0')
										}
									>
										<span className="osvobodi-feature-num d-none d-lg-inline-block">
											{number}
										</span>
										<h2 className="osvobodi-feature-title">
											{title}
										</h2>
										<p>{text}</p>
										<ul className="osvobodi-ticks">
											{bullets.map((b, j) => {
												const idx = b.indexOf(':');
												if (idx === -1) {
													return <li key={j}>{b}</li>;
												}
												return (
													<li key={j}>
														<strong>{b.slice(0, idx)}</strong>
														{b.slice(idx)}
													</li>
												);
											})}
										</ul>
										<Link
											to={href}
											className="btn btn-primary osvobodi-feature-btn py-3 px-5 mt-3"
										>
											{cta}
										</Link>
									</div>

									<div className="col-12 col-lg-6 px-lg-5 d-flex flex-column align-items-center">
										<span className="osvobodi-feature-num d-lg-none align-self-start">
											{number}
										</span>
										<img
											src={image}
											alt={title}
											className="osvobodi-feature-image"
										/>
									</div>
								</div>
							</ScrollAnimation>
						</div>
					</div>
				))}

				<div className="osvobodi-band alt">
					<div className="osvobodi-container">
						<SectionTitle
							undertext="Подземна оптична мрежа за абсолютно спокойствие, закована цена от началото до края и бърза връзка с реален човек"
						>
							<TitleH1>
								Три неща, с които не правим компромис.
							</TitleH1>
						</SectionTitle>

						<div className="row mt-5 justify-content-center">
							{services.map(({ title, text }, i) => (
								<div
									className="col-12 col-sm-6 col-lg-4 mb-4"
									key={i}
								>
									<div className="osvobodi-service-card">
										<div className="osvobodi-service-num">
											{i + 1}.
										</div>
										<h3 className="osvobodi-service-title">
											{title}
										</h3>
										<p className="osvobodi-service-text">{text}</p>
									</div>
								</div>
							))}
						</div>
					</div>
				</div>

				<div className="osvobodi-band">
					<div className="osvobodi-container">
						<ScrollAnimation animateIn="fadeIn" animateOnce={true}>
							<CollapsibleSection
								faqs={faqs}
								sectionTitle={
									<>
										<h2
											className="container mb-5 d-flex justify-content-center align-items-center"
											style={{ whiteSpace: 'pre-wrap' }}
										>
											Често задавани въпроси
										</h2>

									</>
								}
							/>
						</ScrollAnimation>
					</div>
				</div>
			</Layout>
		</div>
	);
};

export const query = graphql`
	query osvobodiSe {
		heroDesktop: file(base: { eq: "hub-desktop.webp" }) {
			childImageSharp {
				fluid(maxWidth: 2000) {
					src
				}
			}
		}
		heroMobile: file(base: { eq: "hub-mobile.webp" }) {
			childImageSharp {
				fluid(maxWidth: 1000) {
					src
				}
			}
		}
	
	}
`;
